
  import { Vue, Component } from "vue-property-decorator";
  import dayjs from "dayjs";
  import infiniteScroll from "vue-infinite-scroll";
  import PostList from "@/components/PostList.vue";
  import { PostService } from "@/services";
  import { WebAgent } from "@/helper";
  import {
    IPaginationSet,
    IAdsModel,
    ISearchBarViewModel,
    ISearchModel
  } from "@/models";

  import { getModule } from "vuex-module-decorators";
  import { Auth } from "@/store/modules/AuthModule";
  import store from "@/store";

  const AuthModule = getModule(Auth, store);
  @Component({
    name: "PageSearch",
    components: { PostList },
    directives: { infiniteScroll }
  })
  export default class PageSearch extends Vue {
    isMobile: boolean = false;
    currentPage: number = 1;
    totalPages: number = 1;
    isLoading: boolean = false;
    result?: IPaginationSet<IAdsModel>;
    PAGE_SIZE: number = 20;
    searchParam: ISearchModel = {} as ISearchModel;
    isAdmin: boolean = false;

    constructor() {
      super();
      this.isLoading = true;
      this.result = {
        page: 0,
        totalPages: 0,
        pageSize: 0,
        count: 0,
        items: [] as IAdsModel[],
        totalCount: 0
      } as IPaginationSet<IAdsModel>;
    }

    mounted() {
      this.checkBrowser();
      this.isAdmin = AuthModule.isAdmin;
      const { date, categoryId, stateId, searchText } = this.$route.params;
      this.searchParam = {
        categoryId: parseInt(categoryId, 0) || 0,
        state: parseInt(stateId, 0) || 0,
        date: parseInt(date, 0) || 0,
        searchText: searchText || ""
      };
      setTimeout(() => {
        // wait for 500ms since vue router not finish
        // call this.$Progress.finish();
        this.onSearch();
      }, 500);
    }

    checkBrowser() {
      this.isMobile = WebAgent.IsMobile();
    }

    get searchText() {
      return this.searchParam.searchText;
    }
    onPageChange(page: number) {
      this.currentPage = page;
      this.onSearch();
    }
    onLoadMore() {
      if (
        this.isLoading === false &&
        this.currentPage < this.result.totalPages
      ) {
        this.currentPage += 1;
        this.onSearch();
      }
    }
    async onSearch() {
      this.isLoading = true;
      if (!this.isMobile) {
        this.$Progress.start();
      }
      const startDate =
        this.searchParam.date === 0
          ? undefined
          : dayjs()
              .subtract(this.searchParam.date, "hour")
              .toDate();
      const endDate =
        this.searchParam.date === 0 ? undefined : dayjs().toDate();
      try {
        const response = await PostService.GetAdsBySearch(
          this.currentPage,
          this.PAGE_SIZE,
          this.searchParam.searchText.trim(),
          this.searchParam.state,
          this.searchParam.categoryId,
          startDate,
          endDate
        );
        if (response.status === 200) {
          const {
            page,
            totalPages,
            pageSize,
            count,
            items,
            totalCount
          } = response.data;
          let tempItems = [];
          // if isMobile dont paging
          if (this.isMobile) {
            tempItems =
              this.currentPage === 1 ? items : [...this.result.items, ...items];
          } else {
            tempItems = items;
          }
          this.result = {
            page,
            totalPages,
            pageSize,
            count,
            totalCount,
            items: tempItems
          };
        } else {
          this.generateError("Failed when loading data");
        }
      } catch (err) {
        this.generateError("Failed when loading data");
      }

      this.isLoading = false;
      if (!this.isMobile) {
        this.$Progress.finish();
      }
    }
    generateError(msg: string) {
      this.$bvToast.toast(`Error: ${msg}`, {
        title: "Error",
        variant: "danger",
        autoHideDelay: 5000
      });
    }
  }
